import { DefaultButton, IconButton, Stack } from '@fluentui/react';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import { IEntityToken } from '../../../API';
import ExpressionBuilder, { ExpressionBuilderOutputType, ExpressionBuilderState } from './ExpressionBuilder';

export class ExpressionFieldState {

	onUpdate: (e: string) => void;

	public editor:ExpressionBuilderState;

	constructor(outputType:ExpressionBuilderOutputType, onUpdate:(e:string) => void, initialValue:string = '') {
		this.editor = new ExpressionBuilderState(outputType, (update) => {
			this.updateExpression(update);
		});

		this.expression = initialValue;
		this.onUpdate = onUpdate;
		
		makeAutoObservable(this);
	}

	public expression:string = '';
	public setExpression(e:string) {
		this.expression = e;
	}

	updateExpression(arg0: string) {
		this.setExpression(arg0);
		this.onUpdate(arg0);
	}

	public setAvailableTokens(columns: IEntityToken[]) {
		this.editor.setAvailableTokens(columns);
	}

	showEditor() {
		this.editor.setExpression(this.expression);
		this.editor.dialog.setVisible(true);
	}
}

function ExpressionField({ state, iconButton }: { state: ExpressionFieldState, iconButton?: boolean }) {

	let getButton = () => {
		if(iconButton){
			return <IconButton iconProps={{iconName:'Code', color:state.expression ? 'gray' : 'blue'}} onClick={() => { state.showEditor(); }} />;
		} else {
			return <DefaultButton iconProps={{iconName:'Code', color:state.expression ? 'gray' : 'blue'}} onClick={() => { state.showEditor(); }}>
				{state.expression ? 'Modify condition' : 'Set a condition'}
			</DefaultButton>;
		}
	};


	return (
		<Stack horizontal>
			
			{getButton()}

			<ExpressionBuilder state={state.editor} />
		</Stack>
	);
}

export default observer(ExpressionField);
